import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { createCallOutbound } from '../../../../api/outbound/pokerOutbounds';
import { ScaledTextButton } from '../../../../components/scaledTextButton';
import { useSocketSend } from '../../../../context/webSocket/webSocketContext';
import { getChipsDisplayStr } from '../../../../utils/chipsDisplayUtils';
export const DomCallButton = ({ bounds, myTurnProperties, showChipsAsBbMultiple, bigBlind }) => {
    const socketSend = useSocketSend();
    const onClickCall = useCallback(() => {
        socketSend(createCallOutbound(myTurnProperties.betSequenceNumber));
    }, [myTurnProperties, socketSend]);
    const additionalChipsToCall = myTurnProperties.betTotalAmountToCall - myTurnProperties.myTotalBetAmount;
    const isAllInToCall = myTurnProperties.myNumChips <= additionalChipsToCall;
    const actionLabel = isAllInToCall ? 'ALL-IN' : 'CALL';
    const subLabel = useMemo(() => {
        const numChips = isAllInToCall ? myTurnProperties.myNumChips : additionalChipsToCall;
        return getChipsDisplayStr({ numChips, showChipsAsBbMultiple, bigBlind, truncateZeroDecimals: false });
    }, [additionalChipsToCall, bigBlind, isAllInToCall, myTurnProperties.myNumChips, showChipsAsBbMultiple]);
    const { x, y, w, h } = bounds;
    return (_jsx(ScaledTextButton, { onClick: onClickCall, label: actionLabel, subLabel: subLabel, testId: 'call', x: x, y: y, w: w, h: h, accentColor: 'blue' }));
};
